import { render, staticRenderFns } from "./dayBarType.vue?vue&type=template&id=20a21185&"
import script from "./dayBarType.vue?vue&type=script&lang=js&"
export * from "./dayBarType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports